import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Chip,
} from '@material-ui/core';
import { i18n } from '../../translate/i18n';

const useStyles = makeStyles(theme => ({
  filterContainer: {
    padding: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  formControl: {
    minWidth: 200,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  greenChip: {
    backgroundColor: '#22c55e',
    color: 'white',
  },
  yellowChip: {
    backgroundColor: '#eab308',
    color: 'white',
  },
  redChip: {
    backgroundColor: '#ef4444',
    color: 'white',
  },
  allChip: {
    backgroundColor: '#6b7280',
    color: 'white',
  },
}));

const IdleStatusFilter = ({ onFilterChange, selectedStatus = 'all' }) => {
  const classes = useStyles();
  const [status, setStatus] = useState(selectedStatus);

  const handleStatusChange = event => {
    const newStatus = event.target.value;
    setStatus(newStatus);
    onFilterChange(newStatus);
  };

  const getStatusLabel = status => {
    switch (status) {
      case 'green':
        return i18n.t('tickets.filters.idleStatus.green');
      case 'yellow':
        return i18n.t('tickets.filters.idleStatus.yellow');
      case 'red':
        return i18n.t('tickets.filters.idleStatus.red');
      default:
        return i18n.t('tickets.filters.idleStatus.all');
    }
  };

  const getStatusColor = status => {
    switch (status) {
      case 'green':
        return classes.greenChip;
      case 'yellow':
        return classes.yellowChip;
      case 'red':
        return classes.redChip;
      default:
        return classes.allChip;
    }
  };

  return (
    <Box className={classes.filterContainer}>
      <FormControl className={classes.formControl} size='small'>
        <InputLabel id='idle-status-filter-label'>
          {i18n.t('tickets.filters.idleStatus.title')}
        </InputLabel>
        <Select
          labelId='idle-status-filter-label'
          value={status}
          onChange={handleStatusChange}
          variant='outlined'
        >
          <MenuItem value='all'>
            <Chip
              label={getStatusLabel('all')}
              size='small'
              className={`${classes.chip} ${getStatusColor('all')}`}
            />
          </MenuItem>
          <MenuItem value='green'>
            <Chip
              label={getStatusLabel('green')}
              size='small'
              className={`${classes.chip} ${getStatusColor('green')}`}
            />
          </MenuItem>
          <MenuItem value='yellow'>
            <Chip
              label={getStatusLabel('yellow')}
              size='small'
              className={`${classes.chip} ${getStatusColor('yellow')}`}
            />
          </MenuItem>
          <MenuItem value='red'>
            <Chip
              label={getStatusLabel('red')}
              size='small'
              className={`${classes.chip} ${getStatusColor('red')}`}
            />
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default IdleStatusFilter;
